import { Link, NavLink } from "react-router-dom"

import "./Sidebar.scss"

import IconList from "~/components/Icons/IconList"
import IconSettings from "~/components/Icons/IconSettings"
import IconExit from "~/components/Icons/IconExit"
import IconDashboard from "~/components/Icons/IconDashboard"
import Tooltip from "~/components/Tooltip/Tooltip"
import { useCountdown } from "~/hooks/useCountdown"
import { useJoinedSpace } from "~/hooks/useJoinedSpace"
import { formattedDuration } from "~/utils/TimeFormatter"
import { calculatePercentage } from "~/utils/TimerUtils"

type SidebarProps = {
  style: "primary" | "secondary"
  onSpacePage?: boolean
  onLeaveButtonClick?: () => void
}

function FollowingTimer() {
  const joinedSpace = useJoinedSpace()
  const timer = joinedSpace?.current_timer ?? null
  const durationLeft = useCountdown(timer)

  if (!timer || !joinedSpace) return null

  const label = timer.break ? "Back to break" : "Back to focus"

  return (
    <Tooltip className="Sidebar__follow-timer" text={label}>
      <Link
        to={`/spaces/${joinedSpace.name}`}
        aria-label={`${label} (${formattedDuration(durationLeft ?? 0)} left)`}
        className={`Sidebar__follow-timer-link Sidebar__follow-timer-link--${
          timer.break ? "break" : "work"
        }`}
        style={
          {
            "--percentage": `${calculatePercentage(timer)}%`,
          } as React.CSSProperties
        }
      >
        <span className="Sidebar__follow-timer-duration">
          {formattedDuration(durationLeft ?? 0)}
        </span>
      </Link>
    </Tooltip>
  )
}

function Sidebar({ style, onSpacePage, onLeaveButtonClick }: SidebarProps) {
  return (
    <nav className={`Sidebar Sidebar--${style}`}>
      <div className="Sidebar__icons">
        {!onSpacePage ? <FollowingTimer /> : null}
        {onSpacePage ? (
          <Tooltip
            className="Sidebar__icon Sidebar__icon--leave"
            text="Exit space"
          >
            <a onClick={onLeaveButtonClick}>
              <IconExit />
            </a>
          </Tooltip>
        ) : null}
        <Tooltip className="Sidebar__icon" text="Spaces">
          <NavLink
            to="/spaces"
            className={({ isActive }) => (isActive ? "selected" : "")}
            end
          >
            <IconList />
          </NavLink>
        </Tooltip>
        <Tooltip className="Sidebar__icon" text="Dashboard">
          <NavLink
            to="/dashboard"
            className={({ isActive }) => (isActive ? "selected" : "")}
          >
            <IconDashboard />
          </NavLink>
        </Tooltip>
        <Tooltip className="Sidebar__icon" text="Settings">
          <NavLink
            to="/settings"
            className={({ isActive }) => (isActive ? "selected" : "")}
          >
            <IconSettings />
          </NavLink>
        </Tooltip>
      </div>
    </nav>
  )
}

export default Sidebar
